import { useQuery } from "react-query";
import { getBreeds } from "../../api/breedApi";

export const useBreed = () => {
  return useQuery("useBreed", () => getBreeds());
};
